import { TQueryType } from '@kurtosys/ksys-app-template/dist/models/query';
import { IConfiguration } from '../models/app/IConfiguration';
import { TEntityType } from '../models/commonTypes';

export const CONFIGURATION: IConfiguration = {
	components: {
		app: {
			applicationId: 'my-global-search',
			cardProps: {
				props: {
					title: 'Global Search'
				}
			}
		},
		input: {
			label: 'Global Site Search',
			// showLabel: true,
			placeholder: 'Enter Fund Name, ISIN, Document Type or Post Titles',
			debounceOptions: {
				enabled: true,
				time: 200,
			},
			minimumOptions: {
				// characterCount: 0,
				// errorMessage: 'Please provide {characterCount} character(s) or more and retry',
				// validateOnUserInput: true,
			},
		},
		callToAction: {
			text: 'Apply Search',
			// showText: false,
			// enabled: false,
		},
		toggleButton: {
			enabled: false,
			showText: false,
			text: 'Show Search',
			icon: {
				asset: 'base.search.magnificationGlass'
			}
		},
		clearSearch: {
			text: 'Clear search term',
			// showText: false,
		},
		results: {
			type: 'internal',
			internalOptions: {
				noSearchTermPlaceholder: {
					show: true,
					text: {
						queryOptionsType: 'none',
						value: 'Please enter a search term to view results.',
					}
				},
				noResultsPlaceholder: {
					text: {
						queryOptionsType: 'none',
						value: 'Your search has yielded no results.'
					}
				},
				allResults: {
					redirectLabel: 'See all search results',
					redirect: {
						defaultUrl: '/results?searchTerm={searchTerm}',
					},
					hide: false,
				},
				entities: {
					label: 'Products',
					redirectLabel: 'SEE ALL',
					redirect: {
						defaultUrl: '/results?tab=products&searchTerm={searchTerm}',
						options: {
							target: '_blank',
						},
					},
					sources: [
						{
							entityType: 'CLSS',
							label: {
								key: 'properties_pub.isin.value',
								queryOptionsType: 'response'
							},
							properties: [
								'isin'
							],
							requestBody: {
								culture: 'en-GB',
								sourceCulture: 'Default',
								translate: true
							},
							url: {
								defaultUrl: '/funds/{entityId}',
								options: {
									target: '_blank'
								}
							}
						},
						{
							entityType: 'CLSS',
							label: {
								queryOptionsType: 'none',
								value: '{sub:shortName} ({sub:fundName})',
								subQueries: [
									{
										queryId: 'shortName',
										key: 'properties_pub.short_name.value',
										queryOptionsType: 'response'
									},
									{
										queryId: 'fundName',
										key: 'properties_pub.fund_name.value',
										queryOptionsType: 'response'
									}
								]
							},
							properties: [
								'fund_name'
							],
							requestBody: {
								culture: 'en-GB',
								sourceCulture: 'Default',
								translate: true
							},
							url: {
								defaultUrl: '/funds/{entityId}',
								options: {
									target: '_blank'
								}
							}
						}
					]
				},
				documents: {
					label: 'Documents',
					redirectLabel: 'SEE ALL',
					redirect: {
						defaultUrl: '/results?tab=documents&searchTerm={searchTerm}',
						options: {
							target: '_blank',
						},
					},
					sources: [
						{
							entityType: 'CLSS',
							properties: {
								meta: ['isin'],
							},
							label: {
								queryOptionsType: 'none',
								value: '{sub:title} ({sub:culture})',
								subQueries: [
									{
										queryId: 'title',
										queryOptionsType: 'document',
										key: 'title'
									},
									{
										queryId: 'culture',
										queryOptionsType: 'document',
										key: 'cultureCode'
									}
								]
							},
							filename: {
								queryOptionsType: 'document',
								options: {
									document: {
										key: 'title',
									},
								},
							},
						},
					],

				},
				dxmContent: {
					label: 'Articles',
					redirect: {
						defaultUrl: '/results?tab=articles&searchTerm={searchTerm}',
					},
					redirectLabel: 'SEE ALL',
					sources: [
						{
							label: {
								key: 'postTitle',
								queryOptionsType: 'response',
							},
							requestBody: {
								searchTerm: '',
								searchType: 'wildcard',
								siteId: 2,
								wordpressInstanceId: 1116,
							},
							type: 'post',
						},
					],
				},
			}
		},
		errorStyles: {
			callToAction: {
				background: {
					color: 'red',
				},
			},
			input: {
				border: {
					_value: '1px solid red',
				},
				outline: {
					color: 'red',
				},
			},
			wrapper: {

			},
		},
	},
	breakpoints: [
		{
			size: 'medium',
			modifier: 'down',
			props: {
				input: {
					label: 'Global Site Search',
					placeholder: 'Enter your search term here...',
				},
			},
		},
	],
};
